import React from "react";
import { Box, Button, Stack } from "@mui/joy";
import { ActionButtonsProps } from "../../../utils/types";

const ApproverActionButtons: React.FC<ActionButtonsProps> = ({ handlers, isForwardParkHidden, isForwardParkDisabled }) => {
  return (
    <Box sx={{ display: "flex", justifyContent: "center", my: 2 }}>
      <Stack direction="row" sx={{ flexWrap: "wrap", justifyContent: "center", gap: "10px" }}>
        {handlers.onEdit && (
          <Button color="primary" variant="soft" onClick={handlers.onEdit} className="heading-4">
            Edit
          </Button>
        )}
        {handlers.onApprove && (
          <Button color="success" variant="soft" onClick={handlers.onApprove} className="heading-4">
            Final Post
          </Button>
        )}
        {handlers.onReject && (
          <Button color="danger" variant="soft" onClick={handlers.onReject} className="heading-4">
            Reject
          </Button>
        )}
        {handlers.onRework && (
          <Button color="warning" variant="soft" onClick={handlers.onRework} className="heading-4">
            Send Back
          </Button>
        )}
        {handlers.onForward && !isForwardParkHidden && (
          <Button color="primary" variant="soft" onClick={handlers.onForward} disabled={isForwardParkDisabled} className="heading-4">
            Forward
          </Button>
        )}
        {handlers.onApproveLogs && (
          <Button color="primary" variant="soft" onClick={handlers.onApproveLogs} className="heading-4">
            Approval Logs
          </Button>
        )}
        {handlers.onAssignto && (
          <Button color="primary" variant="soft" onClick={handlers.onAssignto} className="heading-4">
            Assign to
          </Button>
        )}
        {handlers.onParkInvoice && !isForwardParkHidden && (
          <Button color="success" variant="soft" onClick={handlers.onParkInvoice} disabled={isForwardParkDisabled} className="heading-4">
            Park Invoice
          </Button>
        )}
      </Stack>
    </Box>
  );
};

export default ApproverActionButtons;
